import { createVanIconComponent } from "./van"

const GiftCard = createVanIconComponent("gift-card")
export default GiftCard
